// extracted by mini-css-extract-plugin
module.exports = {"missionBanner":"styles_missionBanner__Ai_mc","missionText":"styles_missionText__JJL1v","description":"styles_description__MvxOg","image":"styles_image__bcDBv"};